import { getVinculacionAppliedAmount } from './vinculacionAmounts'
import { getConciliationAdjustmentDisplay } from './conciliationAdjustmentDisplay'

const movementId = row => String(row?.idPrincipal ?? row?.id_principal ?? row?.id)
const isAdjustment = row => [row?.tabla, row?.tablaPrincipal, row?.origenTabla, row?.libroContableOriginTableId]
  .some(table => [44, 45].includes(Number(table)))

// Al retirar el pago también se libera el saldo que cubría su ajuste.
export const getRemovedConciliationAdjustment = (linked = [], selected = [], documentTotal) => {
  const selectedIds = new Set(selected.map(movementId))
  const seen = new Set()
  return linked.reduce((sum, row) => {
    const id = movementId(row)
    if (!isAdjustment(row) || selectedIds.has(id) || seen.has(id)) return sum
    seen.add(id)
    return sum + (getConciliationAdjustmentDisplay(row, documentTotal)?.adjustment ?? 0)
  }, 0)
}

// Las cuotas de ajuste describen la diferencia; no son otro pago del movimiento.
export const getConciliationBalanceRows = (rows = []) => {
  const normalIds = new Set(rows.filter(row => !isAdjustment(row)).map(movementId))
  const adjustmentIds = new Set()
  return rows.flatMap(row => {
    if (!isAdjustment(row)) return [row]
    const id = movementId(row)
    if (normalIds.has(id) || adjustmentIds.has(id)) return []
    adjustmentIds.add(id)
    return [{ ...row, monto: row.montoTotal ?? 0 }]
  })
}

export const getConciliationBalanceAmount = (row, linked = []) => {
  if (!isAdjustment(row)) return getVinculacionAppliedAmount(row)
  const rows = getConciliationBalanceRows(linked.filter(item => movementId(item) === movementId(row)))
  return rows.length
    ? rows.reduce((sum, item) => sum + getVinculacionAppliedAmount(item), 0)
    : Math.abs(Number(row?.montoTotal) || 0)
}
